export default __webpack_public_path__ + "static/media/collaborator.be00cd74.jpg";